export default __webpack_public_path__ + "static/media/img-api-cat-operational-front.bc89b436.png";